import React, { useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { useVersionCheck } from './useVersionCheck';

export default function UpdateBanner() {
  const updateAvailable = useVersionCheck();
  const [dismissed, setDismissed] = useState(false);

  if (!updateAvailable || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[60] flex items-center gap-3 bg-gray-900/95 dark:bg-black/95 border border-teal-500/40 rounded-lg px-4 py-3 shadow-lg backdrop-blur-sm max-w-xs">
      <RefreshCw size={18} className="text-teal-300 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-white font-medium">Nueva actualización disponible</p>
        <button
          onClick={() => window.location.reload()}
          className="text-xs text-teal-300 hover:text-teal-200 font-semibold mt-1"
        >
          Recargar ahora →
        </button>
      </div>
      <button onClick={() => setDismissed(true)} className="text-gray-500 hover:text-white flex-shrink-0">
        <X size={16} />
      </button>
    </div>
  );
}
